import { Directive, Input } from '@angular/core';
import { CdkHeaderRowDef } from '@angular/cdk/table';

@Directive({
  selector: '[mcraiHeaderRowDef]',
  providers: [{ provide: CdkHeaderRowDef, useExisting: HeaderRowDefDirective }]
})
export class HeaderRowDefDirective extends CdkHeaderRowDef {
  @Input('mcraiHeaderRowDef') columns;
}
